import type { Key } from 'react';

export type Measurement = { key: Key; size: number };
type VirtualScrollRestoreSnapshot = { offset: number; measurements: Measurement[] };

export interface VirtualScrollRestorationCache {
    get(key: string): VirtualScrollRestoreSnapshot | undefined;
    set(key: string, snapshot: VirtualScrollRestoreSnapshot): void;
    delete(key: string): void;
}

function createVirtualScrollRestorationCache(): VirtualScrollRestorationCache {
    return new Map<string, VirtualScrollRestoreSnapshot>();
}

export function getOffset(scrollElement: HTMLElement | Window): number {
    if (scrollElement === window) {
        return window.scrollY;
    }

    return (scrollElement as HTMLElement).scrollTop;
}

export const defaultVirtualScrollRestorationCache = createVirtualScrollRestorationCache();
